var _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalletDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 19,
    viewBox: "0 0 71 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.9903,
    height: 4.38491,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 0.00976562 0)",
    fill: "#6C727F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70.9903,
    height: 4.38491,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 0.00195312 14.4702)",
    fill: "#9EA3AD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.90822,
    height: 10.3776,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 3.22168 4.24316)",
    fill: "#9EA3AD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8.90822,
    height: 10.3776,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 31.0488 4.27881)",
    fill: "#9EA3AD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8.90822,
    height: 10.3776,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 58.875 4.31494)",
    fill: "#9EA3AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletDark);
export default __webpack_public_path__ + "static/media/PalletDark.9fd3c440b964e6bc2a514a9727e5295c.svg";
export { ForwardRef as ReactComponent };